import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "./constants";

// Shared, cached Traditional Screen Print config (colours + one-off charges + min order qty).
let _tspConfigCache = null;
let _tspConfigPromise = null;

export function useTspConfig(enabled) {
  const [config, setConfig] = useState(_tspConfigCache);
  useEffect(() => {
    if (!enabled) return;
    // Cache already available (e.g. fetched by an earlier print group) — adopt it.
    if (_tspConfigCache) {
      setConfig(_tspConfigCache);
      return;
    }
    if (!_tspConfigPromise) {
      _tspConfigPromise = axios
        .get(`${API}/traditional-screen-print/config`)
        .then((res) => {
          _tspConfigCache = res.data;
          return res.data;
        })
        .catch(() => ({ min_order_qty: 1, colours: [1, 2, 3, 4, 5, 6], charges: [] }));
    }
    _tspConfigPromise.then((data) => {
      _tspConfigCache = _tspConfigCache || data;
      setConfig(data);
    });
  }, [enabled]);
  return config || { min_order_qty: 1, colours: [], charges: [] };
}
